import { Component, OnDestroy, OnInit, computed, signal, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AvatarComponent } from '../../../../../shared/components/avatar/avatar.component';
import { CardsApiService } from '../../../../../_services/cards-service/cards-api/cards-api.service';
import { Card, CardBalance, CardBlockReason, CardStatus } from '../../../../../_interfaces/cards.interface';
import { ViewCardComponent } from '../../../../../shared/components/cards/view-card/view-card.component';
import { of, Subscription, tap } from 'rxjs';
import { LoaderComponent } from '../../../../../shared/components/loader/loader.component';
import { switchMap } from 'rxjs/operators';
import { ToastService } from '../../../../../_services/toast-service/toast.service';

@Component({
  selector: 'app-view-card',
  imports: [FormsModule, AvatarComponent, ViewCardComponent, LoaderComponent],
  templateUrl: './employee-card-detail.component.html',
})
export class EmployeeCardDetailComponent implements OnInit, OnDestroy {
  readonly route = inject(ActivatedRoute);
  readonly cardsApiService = inject(CardsApiService);
  readonly toastService = inject(ToastService);

  private readonly cardId: number;
  protected cardDetail = signal<Card>({} as Card);
  private readonly realtimeBalance = signal<CardBalance | null>(null);
  protected cardBalance = computed<CardBalance>(
    () => this.realtimeBalance() ?? { balance: this.cardDetail().balance ?? '' },
  );
  readonly subscriptions = new Subscription();

  constructor() {
    const route = this.route;

    this.cardId = route.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.loadEmployeeCardDetails();
  }

  loadEmployeeCardDetails() {
    if (!this.cardId) return;
    this.subscriptions.add(
      this.cardsApiService
        .getCardPersonalById(this.cardId)
        .pipe(
          tap((card) => this.cardDetail.set(card)),
          switchMap((card) => {
            if (card.status === CardStatus.New) {
              return of(null);
            } else {
              return this.cardsApiService.getPersonalCardBalance(this.cardId);
            }
          }),
        )
        .subscribe({
          next: (balance: CardBalance | null) => {
            if (balance) {
              this.realtimeBalance.set(balance);
            }
          },
          error: () => this.toastService.show('Could not load card balance. ', 'iconoir-xmark'),
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  protected readonly CardBlockReason = CardBlockReason;
}
